import { goalsQuery } from '../../graphql/queries/grid/domain';
import { GoalsQuery } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export class GoalsDataProvider extends BaseDataProvider {
    public fetchMetricsGoals(
        login: string,
        campaignIdIn?: Array<string>
    ): Promise<GoalsQuery> {
        return this.createQuery<GoalsQuery>(goalsQuery, {
            variables: {
                login,
                goalsInput: {
                    filter:
                        campaignIdIn && campaignIdIn.length !== 0
                            ? {
                                  campaignIdIn
                              }
                            : {}
                }
            }
        }).then(result => result.data);
    }
}
